module.exports = __webpack_public_path__ + "static/media/jean-paul-gaultier-classique-big.895908cb.png";